var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c("h2", { staticClass: "title" }, [_vm._v("猩号炒群")]),
    _vm._v(" "),
    _c("div", { staticClass: "search-line" }, [
      _c(
        "div",
        { staticClass: "normal" },
        [
          _vm._v("\n      选择群聊：\n      "),
          _c(
            "el-select",
            {
              staticClass: "search",
              attrs: {
                filterable: "",
                placeholder: "选择群聊",
                "default-first-option": "",
                "remote-method": _vm.searchGroup,
                remote: ""
              },
              model: {
                value: _vm.group_id,
                callback: function($$v) {
                  _vm.group_id = $$v
                },
                expression: "group_id"
              }
            },
            _vm._l(_vm.groupSearchResult, function(item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.id }
              })
            }),
            1
          ),
          _vm._v(" "),
          _vm.group_id
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.deleteGroup } },
                [_vm._v("删除")]
              )
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        { staticStyle: { display: "inline-block" } },
        [
          _c("el-input", {
            staticStyle: { "font-size": "18px" },
            attrs: {
              type: "textarea",
              placeholder: "聊天内容",
              cols: "40",
              rows: "5",
              resize: "none"
            },
            model: {
              value: _vm.words,
              callback: function($$v) {
                _vm.words = $$v
              },
              expression: "words"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", [
      _c("div", { staticClass: "normal" }, [
        _c("input", {
          attrs: { type: "file" },
          on: { change: _vm.chooseImage }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "imageBox" },
        _vm._l(_vm.images, function(img, index) {
          return _c("div", { key: index, staticClass: "imageItem" }, [
            _c("img", { attrs: { src: img, preview: "1" } }),
            _vm._v(" "),
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    return _vm.delImage(index)
                  }
                }
              },
              [_vm._v("删除")]
            )
          ])
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "el-select",
          {
            model: {
              value: _vm.user_way,
              callback: function($$v) {
                _vm.user_way = $$v
              },
              expression: "user_way"
            }
          },
          _vm._l(["随机用户", "当前用户"], function(way) {
            return _c("el-option", {
              key: way,
              attrs: { label: way, value: way }
            })
          }),
          1
        ),
        _vm._v(
          "\n    当前用户：" + _vm._s(_vm.currentUser.nickname || "") + "\n  "
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "normal" },
      [
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.sendMessage } },
          [_vm._v("发送")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4089cc3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4089cc3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/FireGroup.vue
// module id = null
// module chunks = 